import serviceApi from "../apiClient"

export const getQuickServiceApi = () => {
  return serviceApi.get("/holiday/serviceList");
};
